"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createVideoAttachmentStyle;

function createVideoAttachmentStyle() {
  return {};
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9TdHlsZXMvU3R5bGVTZXQvVmlkZW9BdHRhY2htZW50LnRzIl0sIm5hbWVzIjpbImNyZWF0ZVZpZGVvQXR0YWNobWVudFN0eWxlIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQWUsU0FBU0EsMEJBQVQsR0FBc0M7QUFDbkQsU0FBTyxFQUFQO0FBQ0QiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGNyZWF0ZVZpZGVvQXR0YWNobWVudFN0eWxlKCkge1xuICByZXR1cm4ge307XG59XG4iXX0=